export const CODIGO_CREDOR = '1';
